import { Injectable } from '@angular/core';
import { IActivity } from '@shared/interfaces/activity.interface';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';
import { ReferencesActivitiesService } from '@shared/services/references/references.activities.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationReferencesActivitiesService extends PaginationService<IActivity> {
  constructor(_paginable: ReferencesActivitiesService, _logger: LoggerService) {
    super(_paginable, _logger);
  }
}
